const toDataSrc = (vttString: string) => {
  return `data:text/vtt;charset=utf-8,${vttString}`;
};

const fromArray = (
  // timestamp in format: 00:01.000 --> 00:25.000
  arr: Array<{ timestamp: string; text: string }>,
) => {
  return arr.reduce<string>((acc, curr) => {
    return `${acc}\n${formatVttStringFromRow(curr)}`;
  }, 'WEBVTT');
};

const formatVttStringFromRow = (row: { timestamp: string; text: string }) => {
  return `${row.timestamp}\n${row.text.replaceAll('\\N', '\n')}`;
};

const webVTT = {
  toDataSrc,
  fromArray,
};

export default webVTT;
